// import Drag from './drag';
import {DefaultLaTexButton, KayBoardValue} from './config'
import Template from './template';
import Formular from './formula';

class MathEditor {
  constructor(options, fn) {
    this.options = options;
    this.editorId = this.options.id;
    // 输入方式优先级，0默认为自定义公式输入法，1为手写识别.
    this.priority = this.options.priority || 0;
    // 当前题目填空的索引，用于手写识别调用show(index);
    this.index = this.options.index || 0;
    this.MQ = null;
    this.tabEnabled = false;
    this.answerMathField =
      typeof this.answerMathField != "undefined" ? this.answerMathField : {};
    this.answerSpan =
      typeof this.answerSpan != "undefined" ? this.answerSpan : {};

    this.topElements = {
      wrapper: null,
      toolbar: null,
      buttons: null,
    };
    this.buttonMeta = DefaultLaTexButton;
    this.keyboardKeys = KayBoardValue;
    const btns = new Formular({
      subjectId: options.subjectId,
      stage: options.stage,
    });
    this.default_toolbar_buttons =
      options.subjectId && options.stage && btns.length > 0
        ? btns
        : [
            "round_brackets",
            "bracket",
            "less_equal",
            "greater_equal",
            "square",
            "cube",
            "fraction",
            "pi_common",
            "percent",
            "dotx",
            "approx",
            "degree",
            "angle",
            "perpendicular",
            "parallel_to",
            "compare",
            "r_superscript",
            "square_root",
            "root",
            "chinese_or",
            "chinese_and",
            "chinese_both",
            "plus_minus",
            "r_subscript",
            "r_sub_sup",
            "modulus_common",
            "direc_num",
            "direc_duble_num",
            "overrightarrow",
            "ne",
            "cong",
            "simeq",
            "triangle",
            "parallelogram",
            "bigcirc",
            "wideparen",
            "braces",
            "alpha",
            "beta",
            "gamma",
            "theta",
            "delta",
            "phi",
            "Delta",
            "Phi",
            "sin",
            "cos",
            "tan",
            "cot",
            "lefttsrightm",
            "lefttmrights",
            "leftrightm",
            "leftrights",
            "infty",
            "emptyset",
            "in",
            "notin",
            "supseteq",
            "subseteq",
            "supset",
            "subset",
            "cap",
            "cup",
            "complement",
            "complementu",
            "epsilon",
            "rho",
            "omega",
            "Omega",
            "lg",
            "ln",
            "log",
            "csc",
            "sec",
            "binary_equations",
            "ternary_equations",
            "xie",
            "cdot",
            "square_common",
            "square_root_common",
            "l_superscript",
            "l_subscript",
            "l_sub_sup",
            "serial_one",
            "serial_two",
            "serial_three",
            "serial_four",
            "serial_five",
            "serial_six",
            "serial_seven",
            "serial_eight",
            "serial_nine",
            "centigrade",
            "fahrenheit",
            "pi",
            "mu",
            "modulus",
            "rome_one",
            "rome_two",
            "rome_three",
            "rome_four",
            "rome_five",
            "rome_six",
            "rome_seven",
            "rome_eight",
            "rome_nine",
            "rome_teen",
            "xrightarrow_chemical",
            "xlongequal_chemical",
            "xrightleftharpoons_chemical",
            "leftarrow",
            "toarrow",
            "uparrow",
            "downarrow",
          ];

    if (window.MathQuill && options.isEnMode) {
      this.MQ = window.MathQuill.getInterface(2);
      this.answerSpan = document.querySelector(`#${this.options.id}`);
      this.template = new Template(this);
      const MathFieldConfig = {
        maxDepth: 8,
        spaceBehavesLikeTab: true,
        supSubsRequireOperand: true,
      };
      this.answerMathField = this.MQ.MathField(this.answerSpan, {
        ...MathFieldConfig,
        handlers: {
          edit: () => {
            fn && fn();
          },
          enter: () => {},
        },
      });
      window
        .$(`#${this.options.id}`)
        .find("textarea")
        .attr("readonly", "readonly");
      // 如果是PC端，则可以输入
      this.answerMathField.__controller && this.answerMathField.__controller.textarea.focus(
        () => {
          // 初始化内容
          const keyBoard = document.querySelectorAll(".mt-editor-keyboard");
          // 将正在激活中的公式编辑器className设置为非激活
          const activeMathInputField =
            document.querySelector(".mq-math-active");
          if (activeMathInputField)
            activeMathInputField.classList.remove("mq-math-active");
          [].slice.call(keyBoard).forEach((item) => {
            if (!item.classList.contains(`.y-editor-${this.editorId}`)) {
              item.classList.add("hide");
            }
          });
          // 如果优先级为1，则触发手写识别，否则走自定义输入法
          const isHWRInited =
            window.HWRecognizer && window.HWRecognizer.checkInited();
          if (isHWRInited && this.priority == 1) {
            // 手写识别事件处理
            setTimeout(() => {
              this.initHWREvents();
            }, 500);
            window.HWRecognizer && window.HWRecognizer.show(this.index);
            return;
          }
          // 关闭可能的手写识别面板
          window.HWRecognizer && window.HWRecognizer.hide();
          // 如果该题目没有初始化过手写识别，则隐藏切换手写识别的按钮
          // if (!isHWRInited && this.template.switchHwrBtns[0]) {
          //   this.template.switchHwrBtns[0].classList.add("hide");
          // }
          const showStatus = this.showStatus();
          if (showStatus) this.toggle();
          // 设置body的paddingBottom为当前键盘的高度，以便键盘弹出时，不会遮挡输入框
          const curKeyBoardDom = keyBoard[this.index];
          if (curKeyBoardDom) {
            const computedHeight =
              window.getComputedStyle(curKeyBoardDom).height;
            document.body.style.paddingBottom = computedHeight;
            
            // 动画滚动页面到合适的位置
            this.scrollToAppropriatePosition();
          }
        }
      );
      this.closeEditor();
      this.initDelete();
      // this.switchHWR(); // 切换到手写识别
      this.switchContent();
      this.buttonTask();
      setTimeout(() => {
        this.initSwitchInput();
      }, 200)
    } else {
      console.error("Error: Can't find MathQuill.");
    }
  }
  /**
   * 获取当前输入框中的LaTeX值
   * @description 常用于实例之后获取输入框内文本
   */
  getValue() {
    let originalValue = this.answerMathField.latex();
    return originalValue.replace(/\\oversetfrown/g, "\\overset{\\frown}");
  }
  // 初始化手写识别客户端事件
  initHWREvents() {
    // 收起/隐藏事件：用户点击右上角收起按钮；
    let that = this;
    if (window.HWRecognizer) {
      window.HWRecognizer.onhide = (data) => {
        that.hide();
        that.answerMathField.blur();
      };
      // 切换输入方式事件：用户点击左上角切换按钮
      window.HWRecognizer.onswitchinput = (data) => {
        window.HWRecognizer && window.HWRecognizer.hide();
        that.show();
        that.priority = 0;
      };
      // 识别事件：用户手写（HW）、撤销（REVOKE）、反撤销（DECIDE）、清除（CLEAR）、涂抹（DAUB）时，识别到手写内容；
      window.HWRecognizer.onrecognize = (data) => {
        console.log(data, '--- window.HWRecognizer.onrecognize ----');
        try {
          let hwrContent = '';
          const contentRegex = /"content":\s*"([^"]+)"/;
          const matchResult = data.match(contentRegex);
          if (matchResult) {
            hwrContent = matchResult[1];
          }
          that.answerMathField.empty();
          if (hwrContent) {
            // \\sqrt [ 3 ] { ( \\frac { 5 } { 4 } ) ^ { 3 } }
            hwrContent = (hwrContent || "")
              .replace(/\^''/g, "''")
              .replace(/\^'/g, "'")
              .replace(/\\sqrt\s*/g, "\\sqrt");
            this.answerMathField.write(hwrContent);
          } else {
            this.answerMathField.keystroke("Backspace");
          }
        } catch (error) {
          console.log(error, "onrecognize error info");
        }
      };
    }
  }
  /**
   * 初始化删除按钮
   * @description 键盘上删除文本框内容（含中文输入框）
   */
  initDelete() {
    this.deleteBtns = this.template.deleteBtns;
    Array.prototype.forEach.call(this.deleteBtns, (item) => {
      item.addEventListener("click", (e) => {
        this.answerMathField.keystroke("Backspace");
        this.answerMathField.focus();
      });
    });
  }
  /**
   * 不同展示之间切换（符号、英文、中文）
   * @description 符号、英文、中文 三种面板之间的切换
   */
  switchContent() {
    const { switchBtn, switchbackBtn, editorLatexContentEl, editorEnContentEl } =
      this.template;
    switchBtn.addEventListener("click", (e) => {
      editorLatexContentEl.style.display = "none";
      editorEnContentEl.style.display = "block";
      e.target.nextElementSibling.classList.remove("hide");
      e.target.classList.add("hide");
      this.answerMathField.focus();
    });
    switchbackBtn.addEventListener("click", (e) => {
      editorLatexContentEl.style.display = "block";
      editorEnContentEl.style.display = "none";
      e.target.previousElementSibling.classList.remove("hide");
      e.target.classList.add("hide");
      this.answerMathField.focus();
    });
  }
  initSwitchInput() {
    if (window._us_editor_list && window._us_editor_list.length > 1) {
      Array.prototype.forEach.call(this.template.previousInputs, (item) => {
        item.classList.remove("hide");
        item.addEventListener("click", () => {
          window._us_editor_list[
            this.index > 0 ? this.index - 1 : this.index
          ].mathEditor.answerMathField.focus();
        });
      });
      Array.prototype.forEach.call(this.template.nextInputs, (item) => {
        item.classList.remove("hide");
        item.addEventListener("click", () => {
          const inputCount = window._us_editor_list.length;
          window._us_editor_list[
            this.index + 1 < inputCount ? this.index + 1 : this.index
          ].mathEditor.answerMathField.focus();
        });
      });
    }
  }
  /**
   * 键盘按键功能
   * @description 公式符号区域
   */
  buttonTask() {
    const matheditorBtns = document.querySelectorAll(
      `#matheditor-general-${this.editorId} .matheditor-btn-span,#matheditor-en-${this.editorId} .matheditor-btn-span`
    );
    const { editorLatexContentEl, editorEnContentEl } =
      this.template;
    [].slice.call(matheditorBtns).forEach((item) => {
      item.addEventListener("click", (e) => {
        const latex = item.dataset.latex;
        if (latex.toLowerCase() === "capslock") {
          item.style.textTransform = "uppercase";
          const tabContentEnSpan = document.querySelectorAll(
            `#matheditor-en-${this.editorId} .matheditor-btn-span-letter`
          );
          this.toggleCase(item);
          const caseStatus = this.caseStatus(item);
          if (!caseStatus) {
            [].slice.call(tabContentEnSpan).forEach((spanItem) => {
              spanItem.dataset.latex = spanItem.dataset.latex.toLowerCase();
              if (spanItem.innerText) {
                spanItem.innerText = spanItem.innerText.toLowerCase();
              }
            });
          } else {
            [].slice.call(tabContentEnSpan).forEach((spanItem) => {
              spanItem.dataset.latex = spanItem.dataset.latex.toUpperCase();
              if (spanItem.innerText) {
                spanItem.innerText = spanItem.innerText.toUpperCase();
              }
            });
          }
        } else if (latex.toLowerCase() === "backspace") {
          this.answerMathField.keystroke("Backspace");
        } else if (latex.toLowerCase() === "formula") {
          editorLatexContentEl.style.display = "block";
          editorEnContentEl.style.display = "none";
        } else if (latex.toLowerCase() === "close") {
          this.toggle();
        } else {
          const currentLatex = this.answerMathField.latex();
          // 右上标
          if (
            latex == "{}^{}" &&
            currentLatex.indexOf("^{ }") > -1 &&
            this.answerMathField.__options.supSubsRequireOperand
          ) {
            // alert('输入不规范')
            return;
          }
          // 右下标
          // debugger
          if (
            latex == "{}_{}" &&
            currentLatex.indexOf("_{ }") > -1 &&
            this.answerMathField.__options.supSubsRequireOperand
          ) {
            // alert('输入不规范')
            return;
          }
          // 右上下角标
          if (
            latex == "{}_{}^{}" &&
            currentLatex.indexOf("_{ }^{ }") > -1 &&
            this.answerMathField.__options.supSubsRequireOperand
          ) {
            // alert('输入不规范')
            return;
          }
          console.log(latex, currentLatex, "latex");
          this.answerMathField.write(latex);
          if (!/^[a-zA-Z0-9]$/.test(latex)) {
            for (let i = 1; i <= item.dataset.movefor; i++) {
              this.answerMathField.keystroke(item.dataset.moveto);
            }
          }
        }
        // 非关闭按钮，聚焦到编辑框内
        if (latex.toLowerCase() !== 'close') {
          this.answerMathField.focus();
        }
      });
    });
  }
  /**
   * 关闭按钮
   * @description 关闭按钮
   */
  closeEditor() {
    Array.prototype.forEach.call(this.template.closeBtns, (item) => {
      item.addEventListener("click", () => {
        this.toggle();
      });
    });
  }
  /**
   * 关闭手写识别按钮
   * @description 关闭手写识别按钮
   */
  switchHWR() {
    Array.prototype.forEach.call(this.template.switchHwrBtns, (item) => {
      item.addEventListener("click", () => {
        this.hide();
        // 触发手写识别，否则走自定义输入法
        if (this.priority == 0) {
          this.priority = 1;
          this.answerMathField.focus();
          window.HWRecognizer && window.HWRecognizer.show(this.index);
        }
      });
    });
  }
  /**
   * 隐藏
   * @description 点击关闭按钮后隐藏
   */
  hide() {
    document.body.style.paddingBottom = "0px";
    this.template.container.classList.add("hide");
    this.answerSpan.classList.remove("mq-math-active");
    // const placeholderContainer = document.querySelector('.editor-placeholder');
    // if (placeholderContainer) {
    //   placeholderContainer.classList.add('hide');
    // }
  }
  /**
   * 打开
   * @description 打开编辑器看板
   */
  show() {
    this.template.container.classList.remove("hide");
    this.answerSpan.classList.add("mq-math-active");
    // const placeholderContainer = document.querySelector('.editor-placeholder');
    // if (placeholderContainer) {
    //   placeholderContainer.classList.remove('hide');
    // }
  }
  uppercase(item) {
    item.classList.add("uppercase");
  }
  lowercase(item) {
    item.classList.remove("uppercase");
  }
  toggleCase(item) {
    const caseStatus = this.caseStatus(item);
    console.log({ item, caseStatus });
    if (caseStatus) {
      this.lowercase(item);
    } else {
      this.uppercase(item);
    }
  }
  caseStatus(item) {
    return item.classList.contains("uppercase");
  }
  toggle() {
    const showStatus = this.showStatus();
    if (showStatus) {
      this.show();
    } else {
      this.hide();
    }
  }
  showStatus() {
    return this.template.container.classList.contains("hide");
  }
  /**
   * 动画滚动页面到合适的位置
   * @description 当输入框被键盘遮挡时向下滚动，否则不滚动
   */
  scrollToAppropriatePosition() {
    try {
      const inputElement = this.answerSpan;
      if (!inputElement) {
        console.warn('scrollToAppropriatePosition: input element not found');
        return;
      }

      const inputRect = inputElement.getBoundingClientRect();
      if (!inputRect) {
        console.warn('scrollToAppropriatePosition: unable to get input rect');
        return;
      }
      
      // 获取键盘高度
      const keyBoard = document.querySelectorAll(".mt-editor-keyboard");
      if (!keyBoard || keyBoard.length === 0) {
        console.warn('scrollToAppropriatePosition: keyboard elements not found');
        return;
      }

      const curKeyBoardDom = keyBoard[this.index];
      if (!curKeyBoardDom) {
        console.warn(`scrollToAppropriatePosition: keyboard dom at index ${this.index} not found`);
        return;
      }
      
      const computedHeight = window.getComputedStyle(curKeyBoardDom).height;
      const keyboardHeight = parseInt(computedHeight) || 0;
      
      if (keyboardHeight <= 0) {
        console.warn('scrollToAppropriatePosition: invalid keyboard height');
        return;
      }
      
      // 计算键盘弹起后输入框的位置（包含操作条）
      const viewportHeight = window.innerHeight;
      if (!viewportHeight || viewportHeight <= 0) {
        console.warn('scrollToAppropriatePosition: invalid viewport height');
        return;
      }

      const keyboardTop = viewportHeight - keyboardHeight - 60; // 减去操作条高度
      const inputBottom = inputRect.bottom;
      
      // 判断输入框是否被键盘遮挡（包含部分遮挡）
      if (inputBottom + 10 > keyboardTop) {
        // 计算目标滚动位置：确保输入框完全显示在键盘上方
        const overlap = inputBottom - keyboardTop;
        // 目标位置 = 当前位置 + 重叠部分 + 额外间距
        const targetScrollTop = window.pageYOffset + overlap + 20;
        
        console.log({ overlap, currentScrollTop: window.pageYOffset, keyboardHeight, targetScrollTop }, '--- scrollToAppropriatePosition ---');
        
        // 验证目标滚动位置的合理性
        if (targetScrollTop < 0) {
          console.warn('scrollToAppropriatePosition: invalid target scroll top');
          return;
        }
        
        // 使用平滑滚动动画
        window.scrollTo({
          top: targetScrollTop,
          behavior: 'auto'
        });
      }
    } catch (error) {
      console.error('scrollToAppropriatePosition error:', error);
    }
  }

  /**
   * 销毁
   * @description 销毁编辑器看板
   */
  destroy() {
    const outterContainer = document.querySelector(".useditor-outter-container");
    if (outterContainer) {
      outterContainer.remove();
    }
  }
}

export default  MathEditor;
